module.exports = __webpack_public_path__ + "img/cp-03.fa9ccb61.png";